import { initializeApp } from "firebase/app";
import { 
getFirestore,
getDocs,
collection,
 } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import {
  initializeAppCheck,
  ReCaptchaV3Provider
} from 'firebase/app-check';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyBu9WqbfBiE2IJ0TJyydISHH4J5OBwV500",
  authDomain: "prompts2-7b1a9.firebaseapp.com",
  projectId: "prompts2-7b1a9",
  storageBucket: "prompts2-7b1a9.firebasestorage.app",
  messagingSenderId: "539757975833",
  appId: "1:539757975833:web:103823aa433ee5ff384d88"
};


const app = initializeApp(firebaseConfig);

export const storage = getStorage(app);

if (window.location.hostname === 'localhost') {

  // @ts-ignore
  window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;

}

initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider(
    "6LdULuYsAAAAADWso1_URl3ItnLfHpQslOTvV85M"
  ),

  isTokenAutoRefreshEnabled: true
});

// 👉 ESSA LINHA É A MAIS IMPORTANTE
export const db = getFirestore(app);
export const auth = getAuth(app);

export async function getPrompts() {

  try {

    const snapshot =
      await getDocs(
        collection(db, 'prompts')
      );

    return snapshot.docs.map((doc) => ({

      id: doc.id,

      ...doc.data(),

    }));

  } catch (error) {

    console.error(
      'Erro ao buscar prompts:',
      error
    );

    return [];
  }
}